module.exports = __webpack_public_path__ + "img/project-connect.1b9831fb.svg";